import type {Mapper} from 'framework';
import type {SavedMeal, SavedMealLine} from '../../domain/saved-meal';
import type {SavedMealDto} from '../dto/saved-meal.dto';

export class SavedMealDtoToSavedMealMapper implements Mapper<SavedMealDto, SavedMeal> {
  transform(dto: SavedMealDto): SavedMeal {
    const lines: SavedMealLine[] = dto.lines.map(line => ({
      id: line.id,
      displayName: line.displayName,
      quantityGrams: line.quantityGrams,
      kcal: line.kcal,
      proteinGrams: line.proteinGrams,
      carbsGrams: line.carbsGrams,
      fatGrams: line.fatGrams,
      position: line.position,
    }));

    return {
      id: dto.id,
      name: dto.name,
      description: dto.description,
      lines,
      totalKcal: dto.totalKcal,
      totalProteinGrams: dto.totalProteinGrams,
      totalCarbsGrams: dto.totalCarbsGrams,
      totalFatGrams: dto.totalFatGrams,
      createdAt: String(dto.createdAt),
      updatedAt: String(dto.updatedAt),
      lastTouchedAt: String(dto.lastTouchedAt),
    };
  }
}
